import React from 'react';
import {
  TextField,
  Switch,
  FormControlLabel,
  Button,
  makeStyles,
  InputAdornment,
  Box,
} from '@material-ui/core';
import { Editor } from '@tinymce/tinymce-react';

export default function PlanForm({ value, onChange, onSubmit, onPreview, submitting }) {
  const classes = useStyles();

  const handleField = (field) => (e) => {
    const v = field === 'isActive' ? e.target.checked : e.target.value;
    onChange({ ...value, [field]: v });
  };

  const handleDescription = (e) => {
    onChange({ ...value, description: e.target.getContent() });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      <TextField
        label="Nome"
        required
        variant="outlined"
        value={value.name}
        onChange={handleField('name')}
        className={classes.input}
      />
      <TextField
        label="Preço"
        variant="outlined"
        value={value.price}
        onChange={handleField('price')}
        className={classes.input}
        InputProps={{
          startAdornment: <InputAdornment position="start">R$</InputAdornment>,
        }}
      />
      <TextField
        label="Duração"
        variant="outlined"
        value={value.duration}
        onChange={handleField('duration')}
        className={classes.input}
      />
      <TextField
        label="Features"
        variant="outlined"
        value={value.features}
        onChange={handleField('features')}
        className={classes.input}
        multiline
        minRows={3}
      />
      <Box className={classes.switchLine}>
        <FormControlLabel
          control={<Switch checked={!!value.isActive} onChange={handleField('isActive')} color="primary" />}
          label="Ativo"
        />
      </Box>

      <Editor
        apiKey="yhw3ij277yb976ir2snie06bmmixeooxfy2ipu9kz4dl2jj5"
        initialValue={value.description}
        value={value.description}
        init={{
          height: 260,
          menubar: false,
          plugins: [
            'advlist autolink lists link charmap preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime table paste code help wordcount',
          ],
          toolbar:
            'undo redo | bold italic backcolor removeformat | ' +
            'alignleft aligncenter alignright alignjustify | bullist numlist | ' +
            'fontsizeselect',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
        onChange={handleDescription}
      />

      <Box className={classes.actions}>
        <Button variant="outlined" onClick={onPreview} className={classes.button}>Preview</Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={!value.name || submitting}
          className={classes.button}
        >
          {submitting ? 'Salvando...' : 'Salvar'}
        </Button>
      </Box>
    </form>
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  input: {
    width: '100%',
    maxWidth: 420,
  },
  switchLine: {
    alignSelf: 'flex-start',
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center',
    marginTop: theme.spacing(1),
  },
  button: {
    minWidth: 140,
  },
}));
